import React from 'react';

export const ContextCefi = React.createContext();

export const LikutModals = React.createContext();